import { render, staticRenderFns } from "./InsurancePolicyConfirmation.vue?vue&type=template&id=61564582&scoped=true"
import script from "./InsurancePolicyConfirmation.vue?vue&type=script&lang=js"
export * from "./InsurancePolicyConfirmation.vue?vue&type=script&lang=js"
import style0 from "./InsurancePolicyConfirmation.vue?vue&type=style&index=0&id=61564582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61564582",
  null
  
)

export default component.exports